// extracted by mini-css-extract-plugin
export var heart = "like-button-module--heart--oeUfu";
export var heartEmpty = "like-button-module--heart-empty--QA+IG";